import { render, staticRenderFns } from "./Liquidacion_EditarDetalle.vue?vue&type=template&id=596a05ba&scoped=true"
import script from "./Liquidacion_EditarDetalle.vue?vue&type=script&lang=js"
export * from "./Liquidacion_EditarDetalle.vue?vue&type=script&lang=js"
import style0 from "./Liquidacion_EditarDetalle.vue?vue&type=style&index=0&id=596a05ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596a05ba",
  null
  
)

export default component.exports